
<template>
  <div>
      <!-- <mheader></mheader> -->
      <div v-show="tableData.length>0" style="width:1300px;margin:0 auto;" id="v-content" :style="{minHeight:Height+'px'}">
              <!-- 表单内容 -->
         <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">
             <p class="mt-2 font">
                <!-- <img src="../../static/images/kucun.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/> -->
                <span class="p-1 ml-2" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                   入库查询
                </span>
                <span class="ml-5">
                       <span class="mt-2">
                        总共有
                        <span style="color:green;font-size:20px">{{total}}</span>
                        条数据
                      </span>
                      <span class="ml-2">
                        总共有
                      </span>
                      <span style="color:green;font-size:20px">
                          {{Record}}
                      </span>
                      <span>
                        页
                      </span>
                </span>
                 <span class="ml-5">
                    查询时间: 从
                    <span style="color:red">
                        {{searchForm.DateLessThan | changeDate}}
                    </span>
                    到
                    <span style="color:red">
                      {{searchForm.DateMoreThan | changeDate1}}
                    </span>
                </span>
                <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                </span>
              </p>

             <p class="query mb-2 mt-2"><span  style="font-weight:600;">库存详细(凡是没有上传图片的药品，均不显示！双击药品名称或者生产厂家可以快速检索！)</span></p>
                   <div class="row ml-2 mb-2">
                     <div class="col-lg-5">
                          <div class="row">
                             <div class="col-lg-12">
                                 <div class="row">
                                        <div class="col-lg-4">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        药品名称:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                    <input type="text" class="form-control font heit" v-model="searchForm.ypmc" @keydown.enter="searchEnterFun">
                                  </div>
                                  </div>
                               </div>

                                <div class="col-lg-4">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        产地名称:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.cdmc"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div>
                                  </div>
                               </div>
                                <div class="col-lg-4">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        规格:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.gg"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div>

                                  </div>
                               </div>
                                 </div>

                             </div>

                          </div>
                       </div>
                        <div class="col-lg-7">
                             <div class="row">
                                    <div class="col-lg-6">
                                              <div class="row">
                                                        <div class="col-lg-6">
                                                          <div class="row">
                                                              <div class="col-lg-6 P-0">
                                                                  <div class="row ml-lg-1 p-0 font">
                                                                      日期:
                                                                  </div>
                                                              </div>
                                                              <div class="col-lg-6 p-0">
                                                                      <date @changeDate="changeDate1($event)"/>
                                                              </div>
                                                        </div>
                                                      </div>
                                                      <div class="col-lg-6">
                                                          <div class="row">
                                                              <div class="col-lg-6 p-0 text-center font">
                                                                    到:
                                                              </div>
                                                              <div class="col-lg-6 p-0">
                                                                  <date class="picker2"  @changeDate="changeDate2($event)"/>
                                                              </div>
                                                          </div>
                                                      </div>
                                                  </div>
                                    </div>
                                    <div class="col-lg-6">
                                          <div class="row ml-lg-3">
                                                <button class="bg-primary button_zi heit" @click="Search()">查询</button>
                                                <button class="bg-success button_zi ml-lg-2" @click="start_print()">打印页面</button>
                                                <button class="bg-success button_zi ml-lg-2" @click="exportExcel1()">导出本页</button>
                                                <!-- <button class="bg-success button_zi ml-lg-2" @click="exportExcel()">导出查询EXCEL</button> -->
                                        </div>
                                    </div>
                             </div>
                  </div>
                </div>

           <table v-if="searchData.length>0"  class="table table-striped table-hover" ref="print">
               <thead>
                    <tr style="white-space: nowrap;" class="text-center">


                        <th>药品名称</th>
                        <th>产地名称</th>
                        <th>库区</th>
                        <th>规格</th>
                        <th>批号</th>
                        <th>单位</th>
                        <!-- <th>单价</th> -->
                        <!-- <th>金额</th> -->
                        <th>零/整</th>
                        <th>包装</th>
                        <th>数量</th>
                        <!-- <th>有效期至</th> -->
                        <th>入账日期</th>
                        <!-- <th>打折情况</th> -->
                        <!-- <th>返利情况</th> -->
                      </tr>
               </thead>
               <tbody>
                    <tr v-for="(item,index) in searchData" :key="index" class="text-center">

                             <td class="jz_middle" @dblclick="onInputdrugName(index)">{{item.drugName}}<span style='color:red;'>{{item.boss}}</span><span style='color:green;'>{{item.ghdw}}</span></td>
                              <td class="jz_middle" @dblclick="onInputcustomerName(index)">{{item.addr}}</td>
                              <td class="jz_middle">{{item.storeNo}}</td>
                              <td class="jz_middle">{{item.spec}}</td>
                              <td class="jz_middle">{{item.batchNo}}</td>
                              <td class="jz_middle">{{item.unit}}</td>
                              <!-- <td class="jz_middle">{{item.price}}</td> -->
                              <!-- <td class="jz_middle">{{item.money}}</td> -->
                              <td class="jz_middle">{{item.isRetail | lin}}</td>
                              <td class="jz_middle">{{item.package}}</td>
                              <td class="jz_middle">{{item.num}}</td>
                              <!-- <td class="jz_middle">{{item.date}}</td> -->
                              <td class="jz_middle">{{item.date | formatUTC }}</td>
                              <!-- <td class="jz_middle">{{item.disCountRate | rate}}</td> -->
                              <!-- <td class="jz_middle">{{item.isPromotion}}</td> -->
                  </tr>
               </tbody>
            </table>
            <table class="table table-striped table-hover" ref="print" v-else>
                    <thead>
                      <tr style="white-space: nowrap;" class="text-center">


                        <th>药品名称</th>
                        <th>产地名称</th>
                        <th>库区</th>
                        <th>规格</th>
                        <th>批号</th>
                        <th>单位</th>
                        <!-- <th>单价</th> -->
                        <!-- <th>金额</th> -->
                        <th>零/整</th>
                        <th>包装</th>
                        <th>数量</th>
                        <!-- <th>有效期至</th> -->
                        <th>入账日期</th>
                        <!-- <th>打折情况</th> -->
                        <!-- <th>返利情况</th> -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in tableData" :key="index" class="text-center">

                              <td class="jz_middle" @dblclick="onInputdrugName(index)">{{item.drugName}}<span style='color:red;'>{{item.boss}}</span><span style='color:green;'>{{item.ghdw}}</span></td>
                              <td class="jz_middle" @dblclick="onInputcustomerName(index)">{{item.addr}}</td>
                              <td class="jz_middle">{{item.storeNo}}</td>
                              <td class="jz_middle">{{item.spec}}</td>
                              <td class="jz_middle">{{item.batchNo}}</td>
                              <td class="jz_middle">{{item.unit}}</td>
                              <!-- <td class="jz_middle">{{item.price}}</td> -->
                              <!-- <td class="jz_middle">{{item.money}}</td> -->
                              <td class="jz_middle">{{item.isRetail | lin}}</td>
                              <td class="jz_middle">{{item.package}}</td>
                              <td class="jz_middle">{{item.num}}</td>
                              <!-- <td class="jz_middle">{{item.date}}</td> -->
                              <td class="jz_middle">{{item.date}}</td>
                              <!-- <td class="jz_middle">{{item.disCountRate | rate}}</td> -->
                              <!-- <td class="jz_middle">{{item.isPromotion}}</td> -->
                      </tr>
                    </tbody>
                  </table>
                  <!-- 分页 -->
                <div>
                       <v-pagination :total="total" :current-page='current' @pagechange="pagechange"></v-pagination>
                </div>
     <p class="text-center">
        <!-- <img src="../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/> -->
      </p>


  </div>
      </div>
         <div v-show="Pcount===0" style="width:1300px;margin:0 auto;" id="v-content" :style="{minHeight:Height+'px'}">
              <!-- 表单内容 -->
         <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">
             <p class="mt-2 font">
                <!-- <img src="../../static/images/kucun.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/> -->
                <span class="p-1 ml-2" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                   库存查询
                </span>
                <span class="ml-5">
                       <span class="mt-2">
                        总共有
                        <span style="color:green;font-size:20px">{{Record}}</span>
                        条数据
                      </span>
                       <span class="ml-2">
                        总共有
                      </span>
                      <span style="color:green;font-size:20px">
                          {{Record}}
                      </span>
                      <span>
                        页
                      </span>
                </span>
                 <span class="ml-5">
                    查询时间: 从
                    <span style="color:red">
                        {{searchForm.DateLessThan | changeDate}}
                    </span>
                    到
                    <span style="color:red">
                      {{searchForm.DateMoreThan | changeDate1}}
                    </span>
                </span>
                <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                </span>
              </p>

             <p class="query mb-2 mt-2"><span  style="font-weight:600;">库存详细(凡是没有上传图片的药品，均不显示！双击药品名称或者生产厂家可以快速检索！)</span></p>
              <div class="row ml-2 mb-2">
                     <div class="col-lg-5">
                          <div class="row">
                             <div class="col-lg-12">
                                 <div class="row">
                                        <div class="col-lg-4">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        药品名称:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                    <input type="text" class="form-control font heit" v-model="searchForm.ypmc" @keydown.enter="searchEnterFun">
                                  </div>
                                  </div>
                               </div>

                                <div class="col-lg-4">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        产地名称:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.cdmc"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div>
                                  </div>
                               </div>
                                <div class="col-lg-4">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        规格:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.gg"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div>

                                  </div>
                               </div>
                                 </div>

                             </div>

                          </div>
                       </div>
                        <div class="col-lg-7">
                             <div class="row">
                                    <div class="col-lg-6">
                                              <div class="row">
                                                        <div class="col-lg-6">
                                                          <div class="row">
                                                              <div class="col-lg-6 P-0">
                                                                  <div class="row ml-lg-1 p-0 font">
                                                                      日期:
                                                                  </div>
                                                              </div>
                                                              <div class="col-lg-6 p-0">
                                                                      <date @changeDate="changeDate1($event)"/>
                                                              </div>
                                                        </div>
                                                      </div>
                                                      <div class="col-lg-6">
                                                          <div class="row">
                                                              <div class="col-lg-6 p-0 text-center font">
                                                                    到:
                                                              </div>
                                                              <div class="col-lg-6 p-0">
                                                                  <date class="picker2"  @changeDate="changeDate2($event)"/>
                                                              </div>
                                                          </div>
                                                      </div>
                                                  </div>
                                    </div>
                                    <div class="col-lg-6">
                                          <div class="row ml-lg-3">
                                                <button class="bg-primary button_zi heit" @click="Search()">查询</button>
                                                <button class="bg-success button_zi ml-lg-2" @click="start_print()">打印页面</button>
                                                <button class="bg-success button_zi ml-lg-2" @click="exportExcel1()">导出本页</button>
                                                <!-- <button class="bg-success button_zi ml-lg-2" @click="exportExcel()">导出查询EXCEL</button> -->
                                        </div>
                                    </div>
                             </div>
                  </div>
                </div>
          <img src="../../../static/images/wushuju.jpg" style="width:300px;height:300px;display:block;margin:0 auto;" alt="">
     <p class="text-center">
        <!-- <img src="../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/> -->
      </p>


  </div>
       <!-- container -->
      </div>

                <div>
                  <transition name='fade'>
                           <loading v-show="isLoading">

                           </loading>
                  </transition>
                </div>
     </div>
</template>
<script>
import vPagination from "../../components/Pagination.vue";
import Loading from '../../components/Loading.vue'
import date from '../../components/Date.vue'
import { async } from 'q';
export default {
      name: 'SaleQuery',
    data () {
      return {
         Height:0,
        searchForm: {
          ypmc: '',
          cdmc: '',
          ph: '',
          gg: '',
          DateMoreThan: '',
          DateLessThan: '' ,
          DateLessThan1: '',
          DateMoreThan1: '',// 今天+1
        },//搜索内容
        searchData:[],//搜索返回的清单
        isLoading: false,
        tableData: [],
        Record:'',//总记录数
        Pcount:'',//总页数
        excelData:[],
        totalPurchMoney:'',
        PageIndex:1,

         total:1,     // 记录总条数
            display: 20,   // 每页显示条数
            current: 1,   // 当前的页数
      }
    },
    components:{
      vPagination,
        Loading,
        date,
    },
    computed:{

},
filters: {
  //过滤器时间转换
  //时间转换
      formatUTC:function(utc_datetime) {
          return utc_datetime.replace(/T/ig,"  ").substring(0,20)
        } ,
        lin:function(data){
            if(data==1){
              return "零"
            }
            else{
               return "整"
            }
        },
        rate:function(rate){
              if(rate==1){
                   return "不打折"
              }
              else{
                  return "打"+rate*10+"折";
              }
        },
         changeDate(date){
           let change_date=date
           return change_date+" 00:00:00"
      },
      changeDate1(date){
         let time_change=date
        let year=new Date(new Date(time_change).getTime()-24*60*60*1000).getFullYear();

        let month=new Date(new Date(time_change).getTime()-24*60*60*1000).getMonth()+1;

        let time_date=new Date(new Date(time_change).getTime()-24*60*60*1000).getDate();

        let time;
             if(month<10){
                      if(time_date<10)
                       time=year+"-"+"0"+month+"-"+'0'+time_date;
                      else{
                        time=year+"-"+"0"+month+"-"+time_date;
                      }
                  }
                  else{
                     if(time_date<10){
                       time=year+"-"+month+"-"+"0"+time_date;
                     }
                     else{
                       time=year+"-"+month+"-"+time_date;
                     }
                  }

         let change_date=time;
           return change_date+" 23:59:59"
      },
},

methods: {
           getDay(day) {　　
                var today = new Date();　　
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
                var tDate = today.getDate();　　
                tMonth = this.doHandleMonth(tMonth + 1);　　
                tDate = this.doHandleMonth(tDate);　　
                return tYear+"-" + tMonth+"-" + tDate;
            },
            doHandleMonth(month) {　　
                var m = month;　　
                if (month.toString().length == 1) {　　
                    m = "0" + month;　　
                }　　
                return m;
            },
             getDay1(day) {　　
                var today = new Date();　　
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                　　
                var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
                var tDate = today.getDate();　　
                tMonth = this.doHandleMonth(tMonth + 1);　　
                tDate = this.doHandleMonth(tDate);　　
                return tYear + "" + tMonth + "" + tDate;
            },
            doHandleMonth(month) {　　
                var m = month;　　
                if (month.toString().length == 1) {　　
                    m = "0" + month;　　
                }　　
                return m;
            },
        changeDate1:function(date){
          // console.log(date);
         this.searchForm.DateLessThan=date
          this.searchForm.DateLessThan1=date;
        },
       changeDate2:function(date){
        let year=new Date(new Date(date).getTime()+24*60*60*1000).getFullYear();

        let month=new Date(new Date(date).getTime()+24*60*60*1000).getMonth()+1;

        let time_date=new Date(new Date(date).getTime()+24*60*60*1000).getDate();
        // console.log(time_date)
        let time;
             if(month<10){
                      if(time_date<10)
                       time=''+year+"-"+"0"+month+"-"+'0'+time_date;
                      else{
                        time=''+year+"-"+"0"+month+"-"+time_date;
                      }
                  }
                  else{
                     if(time_date<10){
                       time=''+year+"-"+month+"-"+"0"+time_date;
                     }
                     else{
                       time=''+year+"-"+month+"-"+time_date;
                     }
                  }

          this.searchForm.DateMoreThan=time;
          // console.log(time)
          this.searchForm.DateMoreThan1=date;
      },
    //分页
       pagechange:function(currentPage){
         if(this.searchData.length>0){
           this.Search(currentPage)
         }else{

           this.getClerkStoreGoodsQuery(currentPage);
         }
     },

      searchEnterFun(e){
         var keyCode = window.event ? e.keyCode : e.which;
         if(keyCode == 13){
           this.Search();
         }
      },
       //导出方法
       //导出查询页 默认全部查询
                exportExcel() {
                const that=this
                require.ensure([], async () => {
                  const { export_json_to_excel } = require('../../Excel/Export2Excel');//注意这个Export2Excel路径
                  const tHeader = ["药品名称","产地名称","库区","规格","批号","单位","零/整","包装","数量","入账日期"]; // 上面设置Excel的表格第一行的标题
                  const filterVal = ['drugName', 'addr', 'storeNo','spec','batchNo','unit','isRetail','package','num','date']; // 上面的index、nickName、name是tableData里对象的属性key值
                      await that.getExcelData()
                      const list = that.excelData
                     const data = that.formatJson(filterVal, list);
                     export_json_to_excel(tHeader, data, '库存查询');//最后一个是表名字
                })
              },
          //导出当前页
              exportExcel1() {
                require.ensure([], () => {
                  const { export_json_to_excel } = require('../../Excel/Export2Excel');//注意这个Export2Excel路径
                  const tHeader = ["药品名称","产地名称","库区","规格","批号","单位","零/整","包装","数量","入账日期"]; // 上面设置Excel的表格第一行的标题
                  const filterVal = ['drugName', 'addr', 'storeNo','spec','batchNo','unit','isRetail','package','num','date']; // 上面的index、nickName、name是tableData里对象的属性key值
                  if(this.searchData.length>0){
                    const list = this.searchData;  //把要导出的数据tableData存到list
                    const data = this.formatJson(filterVal, list);
                    export_json_to_excel(tHeader, data, '库存查询');//最后一个是表名字
                  }
                  else{
                     const list = this.tableData;  //把要导出的数据tableData存到list
                    const data = this.formatJson(filterVal, list);
                    export_json_to_excel(tHeader, data, '库存查询');//最后一个是表名字
                  }
                })
              },
              formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
              },

      onInputdrugName:function(index){
          if(this.searchData.length>0){
            this.searchForm.ypmc=this.searchData[index].drugName;
          }
          else {
            this.searchForm.ypmc=this.tableData[index].drugName;
          }
      },
      onInputcustomerName:function(index){
          if(this.searchData.length>0)
          {
             this.searchForm.cdmc=this.searchData[index].addr
          }
          else
          {
            this.searchForm.cdmc=this.tableData[index].addr;
          }
      },
      getClerkStoreGoodsQuery: async function (PageIndex) {
          // this.isLoading=true;
        const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'ClerkInStoreQueryAll',
          obj: JSON.stringify({
             PageIndex,
             SearchKey:this.searchForm.ypmc.trim(),
             SearchKey2:this.searchForm.cdmc.trim(),
             SearchKey3:this.searchForm.gg.trim(),
             StartTime:this.searchForm.DateLessThan,
             EndTime:this.searchForm.DateMoreThan,
          })
        })
        // console.log(res)
           if(res.isok){
               const obj=res.data
                this.tableData = obj.rows
                this.total = obj.pcount
                this.Record = obj.record
                this.totalPurchMoney=obj.totalPurchMoney
                // this.isLoading=false
           }
      },
      getExcelData: async function () {
        const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'ClerkInStoreQueryAll',
          obj: JSON.stringify({
             PageIndex:1,
             PageSize:50000,
             SearchKey:this.searchForm.ypmc.trim(),
             SearchKey2:this.searchForm.cdmc.trim(),
             SearchKey3:this.searchForm.gg.trim(),
              StartTime:this.searchForm.DateLessThan,
             EndTime:this.searchForm.DateMoreThan,
          })
        })
        // console.log(res)
        if (res.isok) {
          const obj = res.data
          this.excelData = obj.rows

        }
      },
      //搜索
      Search: async function (PageIndex) {
        //获取三个月前的时间戳   时间条件适合才可以查询
        const that = this
        // let  threeMonth=that.getDay(-3*30);

        // let  threeMonthTime=new Date(threeMonth).getTime()

        // let  today=that.getDay(0);
        // let  todayTime=new Date(today).getTime();

        // let  select=that.searchForm.DateLessThan1;

        // let  select1=that.searchForm.DateMoreThan1;
        // let  seTime=new Date(select).getTime();

        // let  seTime2=new Date(select1).getTime();

        // let ces=that.searchForm.DateLessThan;

        //  let a=ces
        // // console.log(a)
        // let ces1=that.searchForm.DateMoreThan;
        // let b=ces1
        // // console.log(b)
        // let cesTime=new Date(a).getTime();
        //     // console.log(cesTime)
        // let cesTime2=new Date(b).getTime();
        //   // console.log(cesTime2)
        // if(cesTime>=cesTime2){
        //   alert("开始日期要小于结束日期")
        // }
        // else if(cesTime2-cesTime>2592000000){
        //   alert("查询区间最多为一个月")
        // }
        // else{

          // if((threeMonthTime<=seTime&&seTime<=todayTime) && (threeMonthTime<=seTime2&&seTime2<=todayTime)){

            that.isLoading=true;
            that.PageNo = PageIndex || that.PageNo
            const {data: res} = await this.$http.post('Dls/getFun', {
              action: 'ClerkInStoreQueryAll',
              obj: JSON.stringify({
             PageIndex,
             SearchKey:that.searchForm.ypmc.trim(),
             SearchKey2:that.searchForm.cdmc.trim(),
             SearchKey3:that.searchForm.gg.trim(),
             StartTime:that.searchForm.DateLessThan,
             EndTime:that.searchForm.DateMoreThan,
              })
            })

            // console.log(res)
            if(res.isok){
                if(res.data.isok){
                  const obj = res.data;
                   if(that.Pcount===0){
                      that.tableData = obj.rows
                   }
                   else{
                     that.searchData = obj.rows
                   }
               that.Pcount = obj.pcount
              that.Record = obj.record
              that.total = obj.pcount
              that.zje = obj.zje
              that.isLoading=false;
                  if(obj.pcount==0){
                       alert('没有符合条件的信息')
                     that.getClerkStoreGoodsQuery(that.PageIndex);
                  }
                }
                else{
                   that.isLoading=false;
                  alert(res.data.msg)
                }


          }

          // }
          // else{
          //   alert("请选择三个月以内的时间进行查询,查询日期不大于当天")
          // }

        // }

      },



      //搜索功能
     // 打印
    start_print(){
        this.$print(this.$refs.print);//$refs的值要和html里的ref一致
    }

    },
     mounted(){
          //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100;
　　//监听浏览器窗口变化　
    window.onresize = ()=> {this.Height = document.documentElement.clientHeight -100}

    },
     created () {
       this.searchForm.DateMoreThan=this.getDay(1)
      this.searchForm.DateLessThan=this.getDay(0)
        this.getClerkStoreGoodsQuery(this.PageIndex);
      this.searchForm.DateLessThan1=this.getDay(-1)
      this.searchForm.DateMoreThan1=this.getDay(0)
    }
}
</script>
<style scoped>
   .table-hover>tbody>tr:hover {
    background-color:#dee2e6!important;
}
.font{
  font-size:15px;
}
.font_yz{
  font-size:1px;
  color:red;
}
.button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;
  }
  .heit{
    height:1.5rem;
  }
  .span_close:hover{
       color:#3190e8;
 }

.autocut{
     overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      -o-text-overflow:ellipsis;
     -khtml-text-overflow: ellipsis;
     -moz-text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
}
.jz_middle{
   vertical-align:middle;
 }
</style>



// WEBPACK FOOTER //
// src/pages/Lihui/LhStoreQuery.vue